// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-dates[data-v-c23c2f82]{margin:20px 0}.main-dates img[data-v-c23c2f82]{display:none;max-width:100%}.main-dates img.desktop-image[data-v-c23c2f82]{display:block}.main-dates img.mobile-image[data-v-c23c2f82]{display:none}@media(max-width:575.98px){.main-dates img.desktop-image[data-v-c23c2f82]{display:none}.main-dates img.mobile-image[data-v-c23c2f82]{display:block}}", ""]);
// Exports
module.exports = exports;
